<script>

  import { External, M } from '../../external';
  import { onDestroy, onMount } from 'svelte';
  import { makeWebsiteRequest } from '../../Common/tools';
  import { fade } from 'svelte/transition';

  export let amount, futureAmount, currency, settings;
  let paypalInstance;
  let connectedPayPal = false;

  let paypalData = {
    cardType: '',
    nonce: '',
    paypalEmail: '',
    paypalCountry: ''
  };

  export const onAmountChange = () => {
  };

  export const getPaymentDetails = async (billingInfo) => {
    return paypalData;
  };

  let setup = async () => {
    let result = await makeWebsiteRequest({
      action: 'getClientToken'
    });

    window.braintree.client.create({
      authorization: result.data
    }, (err, clientInstance) => {
      if (err) {
        alert(err);
      } else {
        window.braintree.paypal.create({
          client: clientInstance
        }, (paypalErr, instance) => {
          if (paypalErr) {
            External.CPanel.showError(paypalErr);
            External.Log.error(paypalErr);
          }
          paypalInstance = instance;
        });
      }
    });
  };

  let disconnectPayPal = () => {
    paypalData.cardType = '';
    paypalData.nonce = '';
    paypalData.paypalEmail = '';
    paypalData.paypalCountry = '';
    connectedPayPal = false;
  };

  let connectPayPal = () => {
    if (!paypalInstance) {
      return;
    }

    paypalInstance.tokenize({
      flow: 'vault'
    }, (tokenizeErr, payload) => {
      if (tokenizeErr) {
        if (tokenizeErr.type !== 'CUSTOMER') {
          External.Log.error(tokenizeErr);
          External.CPanel.showError(tokenizeErr.message || M.ERR_BRAINTREE_UNKNOWN);
        }
        return;
      }

      paypalData.cardType = 'PayPal';
      paypalData.nonce = payload.nonce;
      paypalData.paypalEmail = payload.details.email;
      paypalData.paypalCountry = payload.details.countryCode;
      connectedPayPal = true;
    });
  };

  onMount(() => {
    External.WebPlatform.requestScripts([{
      script: 'https://js.braintreegateway.com/web/3.115.2/js/client.min.js',
      check: () => window.braintree?.client
    }, {
      script: 'https://js.braintreegateway.com/web/3.115.2/js/paypal.min.js',
      check: () => window.braintree?.paypal
    }], setup);
  });

  let teardown = () => {
    return new Promise((resolve, reject) => {
      try {
        if (paypalInstance) {
          paypalInstance.teardown(() => {
            paypalInstance = null;
            resolve();
          });
        }
      } catch (error) {
        resolve();
      }
    });
  };

  onDestroy(teardown);
</script>

<div class="payment-info">
  {#if connectedPayPal}
    <div class="col20 f-left connected-paypal-account" in:fade>
      <h4 style="margin-bottom:15px;">{M.CRED_CARD_INFO}</h4>
      <span class="paypal-mail col20 f-left">
        <span>{paypalData.paypalEmail}</span>
        <a on:click={disconnectPayPal}>&#10005;</a>
      </span>
      <span class="col20 f-left light-font">{M.SWITCH_PAYMENTS}</span>
    </div>
  {:else}
    <div class="col20 f-left card-form" in:fade>
      <h4 style="margin-bottom:15px;">{M.CRED_CARD_INFO}</h4>
      <div class="col20 f-left">
        <a id="paypalContainer" on:click={connectPayPal}>
          <img src="https://www.paypalobjects.com/webstatic/en_US/i/btn/png/silver-rect-paypal-44px.png" alt="PayPal" style="margin-left: 0">
        </a>
      </div>
    </div>
  {/if}
</div>
